import { render } from "./Forecast.vue?vue&type=template&id=dddf17b6"
import script from "./Forecast.vue?vue&type=script&lang=js"
export * from "./Forecast.vue?vue&type=script&lang=js"
script.render = render

export default script